import { appendAkamaiHeaders } from 'lib/utilities/akamaiHeaders';
import { EnvConfig } from 'types';

export async function getDictionary(dictionaryName: string, languageCode: string, config: EnvConfig): Promise<Record<string, string>> {
	const { endpoints } = config;
	const url = `${endpoints.dictionaryApi}?langCd=${languageCode}&dictName=${dictionaryName}`;

	return fetch(url, {
		method: 'GET',
		headers: appendAkamaiHeaders({
			'Content-Type': 'application/json',
		}),
	})
		.then((response) => response.json())
		.then((json) => json);
}
